import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, CalendarCheck } from "lucide-react";

export const links = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/a-propos", label: "À propos" },
  { to: "/faq", label: "FAQ" },
];

const Brand = ({ onClick }) => (
  <div className="flex items-center gap-3 sm:gap-5">
    <Link to="/" data-testid="nav-logo" className="flex items-center" onClick={onClick}>
      <img src="/assets/logo-argia-wide.png" alt="ARGIA Admin — Donnez de la clarté à votre administratif" className="h-9 w-auto sm:h-11" />
    </Link>
    <span className="h-9 w-px bg-[#2C2A29]/15" aria-hidden="true" />
    <a
      href="https://www.aadprox.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="nav-aadprox-franchise"
      className="flex items-center gap-2 sm:gap-3"
      title="Franchisée du réseau AADPROX"
    >
      <span className="hidden text-[10px] font-semibold uppercase leading-tight tracking-[0.22em] text-argia-muted sm:block">
        Franchisée
      </span>
      <img src="/assets/logo-aadprox-wide.png" alt="AADPROX — réseau national d'accompagnement administratif" className="h-10 w-auto sm:h-[52px]" data-testid="nav-aadprox-logo" />
    </a>
  </div>
);

const MobileNav = ({ onNavigate }) => (
  <nav className="border-t border-[#2C2A29]/10 bg-[#FDFBF7] px-6 py-6 xl:hidden" data-testid="nav-mobile">
    <div className="flex flex-col gap-4">
      {links.map((l) => (
        <NavLink
          key={l.to}
          to={l.to}
          onClick={onNavigate}
          className={({ isActive }) => `text-base font-medium ${isActive ? "text-argia-red" : "text-argia-ink"}`}
        >
          {l.label}
        </NavLink>
      ))}
      <Link
        to="/rendez-vous"
        onClick={onNavigate}
        data-testid="nav-mobile-cta-rdv"
        className="mt-2 inline-flex w-fit items-center gap-2 rounded-full bg-argia-red px-5 py-2.5 text-sm font-semibold text-white"
      >
        <CalendarCheck size={16} strokeWidth={1.5} />
        Prendre rendez-vous
      </Link>
    </div>
  </nav>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="sticky top-0 z-50 bg-[#FDFBF7]/80 backdrop-blur-xl border-b border-[#2C2A29]/10">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Brand onClick={close} />

        <nav className="hidden items-center gap-8 xl:flex" data-testid="nav-desktop">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s|à/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-300 hover:text-argia-red ${isActive ? "text-argia-red" : "text-argia-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/rendez-vous"
            data-testid="nav-cta-rdv"
            className="hidden items-center gap-2 rounded-full bg-argia-red px-5 py-2.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-argia-redDark hover:-translate-y-0.5 xl:inline-flex"
          >
            <CalendarCheck size={16} strokeWidth={1.5} />
            Prendre rendez-vous
          </Link>
          <button data-testid="nav-mobile-toggle" className="xl:hidden text-argia-ink" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && <MobileNav onNavigate={close} />}
    </header>
  );
};
